import {
  ThemeProvider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { customTheme } from "./theme/theme.tsx";
import AppLogo from "./components/app-logo.tsx";
import ReferralBanner from "./components/referral-banner.tsx";
import BrandingList from "./components/branding-list.tsx";
import GamingLicense from "./components/gaming-license.tsx";
import Certifications from "./components/certifications.tsx";
import CustomerReview from "./components/customer-review.tsx";
import GamePayoutRate from "./components/game-payout-rate.tsx";
import LiveTransaction from "./components/live-transaction.tsx";
import FooterBannerImage from "./components/footer-banner-image.tsx";
// import HamsterBanner from "./components/hamster-banner.tsx";
const AppBackground = require("./images/app-bg.png");

export default function App() {
  const backgroundStyle = {
    backgroundImage: `url(${AppBackground})`,
    backgroundSize: "cover", // Ensures the image covers the entire container
    backgroundPosition: "center center", // Centers the image
    minHeight: "100vh", // Takes up the full height of the viewport
    width: "100%", // Takes up the full width of the viewport
    backgroundRepeat: "repeat", // Repeat the background image vertically
  };
  // http-server ./build
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={customTheme}>
      <div style={backgroundStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              padding: isMobile ? "15px" : "50px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "30px",
              maxWidth: "600px",
            }}
          >
            <AppLogo isMobile={isMobile} />
            <ReferralBanner isMobile={isMobile} />
            <BrandingList isMobile={isMobile} />
            <LiveTransaction isMobile={isMobile} />
            <GamePayoutRate isMobile={isMobile} />
            <CustomerReview isMobile={isMobile} />
            {/* <HamsterBanner /> */}

            <GamingLicense isMobile={isMobile} />
            <Certifications isMobile={isMobile} />
            {/* <FooterBannerImage isMobile={isMobile} /> */}
            <Typography style={{ fontSize: "16px", fontWeight: "500" }}>
              © 2024 GOLD GROUP POKIES
            </Typography>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
